import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { NavbarVerticalComponent } from './components/navbar-vertical/navbar-vertical.component';
import { NavbarTopComponent } from './components/navbar-top/navbar-top.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    NavbarVerticalComponent,
    NavbarTopComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule
  ],
  exports: [
    NavbarVerticalComponent,
    NavbarTopComponent
  ]
})
export class NavbarModule { }
